import { Routes } from '@angular/router';
import { LogoutDetectionGuard } from './shared/guards/logout-detection.guard';
import { MyGarageComponent } from './my-garage/my-garage.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadComponent: () => import('./components/home/home.component')
      .then(c => c.HomeComponent)
      .catch(err => {
        console.error('Failed to load home component:', err);
        throw new Error('Failed to load home page. Please refresh and try again.');
      }),
  },
  {
    path: 'register',
    loadComponent: () => import('./components/register/register.component').then(c => c.RegisterComponent),
  },
  {
    path: 'cart',
    loadComponent: () => import('./components/cart/cart.component').then(c => c.CartComponent),
    canActivate: [LogoutDetectionGuard]
  },
  {
    path: 'cart/:id',
    loadComponent: () => import('./components/cart/cart.component').then(c => c.CartComponent),
    canActivate: [LogoutDetectionGuard]
  },
  {
    path: 'product-list',
    loadComponent: () => import('./components/product-list/product-list.component')
      .then(c => c.ProductListComponent)
      .catch(err => {
        console.error('Failed to load product-list component:', err);
        // Return a fallback component or redirect to error page
        throw new Error('Failed to load product list page. Please refresh and try again.');
      }),
  },
  {
    path: 'product-detail/:id',
    loadComponent: () => import('./components/product-detail/product-detail.component')
      .then(c => c.ProductDetailComponent)
      .catch(err => {
        console.error('Failed to load product-detail component:', err);
        throw new Error('Failed to load product detail page. Please refresh and try again.');
      }),
  },
  {
    path: 'booking-page',
    loadComponent: () => import('./components/booking-page/booking-page.component').then(c => c.BookingPageComponent),
  },
    {
    path: 'my-garage',
    loadComponent: () => import('./my-garage/my-garage.component').then(c => c.MyGarageComponent),
  },
  {
    path: 'user-profile',
    loadComponent: () => import('./components/user-profile/user-profile.component').then(c => c.UserProfileComponent),
    canActivate: [LogoutDetectionGuard],
    children: [
      { path: 'orders', loadComponent: () => import('./components/orders/orders.component').then(c => c.OrdersComponent) },
      { path: 'address', loadComponent: () => import('./components/user-address/user-address.component').then(c => c.UserAddressComponent) },
      { path: 'wishlist', loadComponent: () => import('./components/wishlist/wishlist.component').then(c => c.WishlistComponent) },
                    { path: 'notifications', loadComponent: () => import('./components/notification-alert/notification-alert.component').then(c => c.NotificationAlertComponent) },
       { path: 'coupons', loadComponent: () => import('./components/coupons-offers/coupons-offers.component').then(c => c.CouponsOffersComponent) },
       { path: 'scrap-certificate', loadComponent: () => import('./components/scrap-certificate/scrap-certificate.component').then(c => c.ScrapCertificateComponent) },
       { path: 'my-garage', loadComponent: () => import('./my-garage/my-garage.component').then(c => c.MyGarageComponent) },
      //  { path: 'help', loadComponent: () => import('./components/faq/faq.component').then(c => c.FaqComponent) },
       { path: 'profile-faq', loadComponent: () => import('./components/profile-faq/profile-faq.component').then(c => c.ProfileFaqComponent) },
       { path: 'customer-support', loadComponent: () => import('./components/customer-support/customer-support.component').then(c => c.CustomerSupportComponent) }
    ]
  },
  // {
  //   path: 'order',
  //   loadComponent: () => import('./components/orders/orders.component').then(c => c.OrdersComponent)
  // },
  {
    path: 'orders-details',
    loadComponent: () => import('./components/orders-detail-summary/orders-detail-summary.component').then(c => c.OrdersDetailSummaryComponent),
    canActivate: [LogoutDetectionGuard]
  },
  {
    path: 'order-status',
    loadComponent: () => import('./components/order-confirmation/order-confirmation.component').then(c => c.OrderConfirmationComponent),
    canActivate: [LogoutDetectionGuard]
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./components/privacy-policy/privacy-policy.component').then(c => c.PrivacyPolicyComponent)
  },
  {
    path: 'terms-condition',
    loadComponent: () => import('./components/terms-condition/terms-condition.component').then(c => c.TermsConditionComponent)
  },
  {
    path: 'blog-stories',
    loadComponent: () => import('./components/blog-stories-list/blog-stories-list.component').then(c => c.BlogStoriesListComponent)
  },
  {
    path: 'view-other',
    loadComponent: () => import('./components/view-other/view-other.component').then(c => c.ViewOtherComponent)
  },
  { path: 'profile-faq', loadComponent: () => import('./components/profile-faq/profile-faq.component').then(c => c.ProfileFaqComponent),
    canActivate: [LogoutDetectionGuard] },

  {
    path: 'wishlist',
    loadComponent: () => import('./components/wishlist/wishlist.component').then(c => c.WishlistComponent),
    canActivate: [LogoutDetectionGuard]
  },
  {
    path: 'coupons',
    loadComponent: () => import('./components/coupons-offers/coupons-offers.component').then(c => c.CouponsOffersComponent),
    canActivate: [LogoutDetectionGuard]
  },
  {
    path: 'notification-alert',
    loadComponent: () => import('./components/notification-alert/notification-alert.component').then(c => c.NotificationAlertComponent),
    canActivate: [LogoutDetectionGuard]
  },
  {
    path: 'scrap-certificate',
    loadComponent: () => import('./components/scrap-certificate/scrap-certificate.component').then(c => c.ScrapCertificateComponent),
    canActivate: [LogoutDetectionGuard]
  },
  { path: 'customer-support', loadComponent: () => import('./components/customer-support/customer-support.component').then(c => c.CustomerSupportComponent),
    canActivate: [LogoutDetectionGuard] }

];
